module.exports = __webpack_public_path__ + "media/images/icon__point--white-7cf7b5ac289609b5b11a1f6d1494a17a.png";